import type { BrowserOptions, NodeOptions } from '@sentry/nextjs'

export const sentryOptions: NodeOptions | BrowserOptions = {
    dsn: 'https://21c438116884488993d944bb643cb906@o476415.ingest.sentry.io/5530269',
    enabled: process.env.NODE_ENV === 'production',
    tracesSampleRate: 0,
    environment: process.env.SENTRY_ENV,
    maxBreadcrumbs: 50,
    attachStacktrace: true,
    ignoreErrors: [
        'extension',
        'window.__pad.performLoop',
        // https://github.com/Doist/Todoist-Landing-Pages/issues/2330
        // Likely culprit is Microsoft link checking or a similar service
        'Non-Error promise rejection captured with value: Object Not Found Matching Id:',
        // This is a Safari bug with LD-JSON. The LD-JSON is valid but Safari attempts to parse and execute it as JS,
        // when the attribute type="application/ld+json" is present
        // Given search engine bots don't use Safari/Webkit, and it's valid LD-JSON, we can ignore it
        'r["@context"].toLowerCase',
        'updateClickListeners(app:///ads/pixel.js',
        // Looks like a Next.js bug.
        // See: https://github.com/vercel/next.js/discussions/61734.
        'Invariant: attempted to hard navigate to the same URL',
    ],
    allowUrls: ['https://todoist.com', 'https://www.todoist.com', 'http://todoist.b-cdn.net'],
}
